<template>
	<div id="offers-table">
		<table class="table" v-if="tableRows.length != 0 && !isLoadingOffers">
			<thead class="table__header">
				<tr>
					<th
						v-for="(header, index) in tableHeader"
						@click="orderByHeader(header, index)"
						:class="header.field == 'edit' || header.field == 'delete' ? 'icon' : ''"
						:key="index"
					>
						<div class="row">
							<span :class="header.field == 'actions' ? '' : 'pointer'">{{ header.label }}</span>
							<SortUpDown
								v-if="header.field !== 'actions'"
								:isActive="header.isActive"
								:alt="'Ordenar por ' + header.label"
							/>
						</div>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr
					v-for="(row, index) in tableRows"
					:key="row.id"
					:class="[index % 2 == 0 ? 'stripped' : '', row.isInvalid ? 'invalid' : '']"
				>
          <td>
						{{ row.shortDescription }}
					</td>
					<td>
						{{ row.originator != null ? row.originator.name : ' - ' }}
					</td>
					<td>
						{{ row.industryType != null ? row.industryType.name : ' - ' }}
					</td>
					<td>
						{{ row.operationType != null ? row.operationType.name : ' - ' }}
					</td>
					<td>
						{{ row.serie }}
					</td>
					<td>
						{{ row.offerStatus != null ? row.offerStatus.name : ' - ' }}
					</td>
					<td>
						{{ row.createdAt | date }}
					</td>
					<td class="actions">
						<div @click="editRow(row)">
							<Tooltip :informationText="'Editar'" :actionIcon="'EditIcon'" />
						</div>
						<div @click="uploadFile(row)">
							<Tooltip informationText="Upload carteira" :actionIcon="'FileUploadIcon'" />
						</div>
						<div @click="cloneRow(row)">
							<Tooltip :informationText="'Clonar'" :actionIcon="'DuplicateIcon'" />
						</div>
						<div @click="gotoReportPage(row)" v-if="row.offerStatus.id === 4">
							<Tooltip :informationText="'Envio de Relatório'" :actionIcon="'ReportIcon'" />
						</div>
						<div @click="handleDeleteModal(row)">
							<Tooltip :informationText="'Excluir'" :actionIcon="'DeleteIcon'" />
						</div>
					</td>
				</tr>
			</tbody>
			<DeleteModal
				:title="'Excluir Oferta'"
				:subtitle="'Tem certeza que deseja excluir esta oferta?'"
				:loader="isLoadingOffers"
				v-show="showDeleteModal"
				@handleDeleteModal="handleDeleteModal()"
				@confirmDelete="confirmDelete()"
			/>
		</table>
		<div class="loader" v-if="isLoadingOffers">
			<SpinnerIcon :color="'#597393'" />
		</div>
		<Pagination
			v-if="tableRows.length != 0 && !isLoadingOffers"
			:totalPages="totalPages"
			:currentFromReq="currentPage"
			@tableRequest="tableRequest"
		/>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { DELETE_OFFER } from '@/store/modules/offerManagement/actions';
import SidebarArrow from '@/components/shared/Icons/SidebarArrow.vue';
import Pagination from '@/components/shared/Pagination/Pagination';
import SpinnerIcon from '@/components/shared/Icons/SpinnerIcon';
import SortUpDown from '@/components/shared/Icons/SortUpDown.vue';
import OfferActionsForm from '@/components/modules/Offer/OfferDetail/OfferActionsForm/OfferActionsForm.vue';
import DeleteModal from '@/components/shared/DeleteModal/DeleteModal.vue';
import Tooltip from '@/components/shared/Tooltip/Tooltip.vue';

export default {
	name: 'Table',
	components: {
		SidebarArrow,
		Pagination,
		SpinnerIcon,
		SortUpDown,
		DeleteModal,
		OfferActionsForm,
		Tooltip,
	},
	props: {
		isWeb: {
			required: true,
		},
		currentPage: {
			required: true,
		},
	},
	data: () => ({
		showDeleteModal: false,
		rowId: '',
		tableHeader: [
			{
				field: 'name',
				label: 'Nome',
				isActive: null,
			},
			{
				field: 'originator',
				label: 'Empresa - Originador',
				isActive: null,
			},
			{
				field: 'industryType',
				label: 'Indústria',
				isActive: null,
			},
			{
				field: 'operationType',
				label: 'Tipo de Operação',
				isActive: null,
			},
			{
				field: 'serie',
				label: 'Série',
				isActive: null,
			},
			{
				field: 'status',
				label: 'Status',
				isActive: null,
			},
			{
				field: 'createdAt',
				label: 'Data de Criação',
				isActive: null,
			},
			{
				field: 'actions',
				label: 'Ações',
				isActive: null,
			},
		],
	}),
	mounted() {},
	methods: {
		...mapActions('offerManagement', {
			deleteOffer: DELETE_OFFER,
		}),
		tableRequest(param) {
			this.$emit('changePage', param);
		},
		orderByHeader(param, index) {
			if (param.field == 'actions') return;
			this.setArrowIcon(index);
			this.$emit('orderByHeader', param.field);
		},
		setArrowIcon(index) {
			if (this.tableHeader[index].isActive === null) {
				this.tableHeader[index].isActive = false;
			} else {
				this.tableHeader[index].isActive = !this.tableHeader[index].isActive;
			}
			this.tableHeader = this.tableHeader.map((el, idx) => {
				if (idx !== index) {
					el.isActive = null;
				}
				return el;
			});
		},
		editRow(row) {
			this.$router.push({
				path: '/dashboard/offer/detail',
				query: { id: row.id },
			});
		},
		cloneRow(row) {
			this.$router.push({
				path: '/dashboard/offer/detail',
				query: { id: row.id, action: 'clone' },
			});
		},
		handleDeleteModal(row) {
			this.showDeleteModal = !this.showDeleteModal;
			this.rowId = row != null ? row.id : null;
		},
		confirmDelete() {
			this.deleteOffer({ vm: this, id: this.rowId })
				.then((res) => {
					this.handleDeleteModal(null);
					if (res.status == 200) {
						this.$emit('refreshOffers');
					}
				})
				.catch((e) => {
					this.handleDeleteModal(null);
				});
		},
		uploadFile(row) {
			const { originator, id } = row;
			this.$router.push({
				name: 'FileUpload',
				params: {
					originatorName: originator.name,
					originatorId: originator.id.toString(),
					offerId: id,
				},
			});
		},
		gotoReportPage(offer) {
			if (offer.offerStatus.id === 4) {
				this.$router.push({ name: 'offer-report', params: { id: offer.id } });
			}
		},
	},
	computed: {
		...mapGetters('offerManagement', ['offerList', 'isLoadingOffers']),
		tableRows() {
			const rows = this.offerList.offers != undefined ? this.offerList.offers : [];

			return !rows.length ? [] : rows;
		},
		totalPages() {
			const pagination = this.offerList.totalPages != undefined ? this.offerList.totalPages : 1;

			return pagination;
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'Table.scss';
</style>
